import PropTypes from "prop-types";

import BookmarkButton from "@/components/BookmarkButton";
import { BookmarkContextProvider } from "@/users/useBookmarkContent/useBookmarkContent";
import { popOutOptionCss } from "../../ActionPopOutOption/ActionPopOutOption.style";
import { sharedButtonCss } from "../../SecondaryActionsToolbar/SecondaryActionButton/SecondaryActionButton.style";
import {
  buttonCss,
  buttonOverrideCss,
  desktopIconCss,
  labelCss,
  mobileIconCss,
} from "./SaveAction.style";

const propTypes = {
  activeSubMenu: PropTypes.string,
  contentId: PropTypes.string,
  currentLevel: PropTypes.object,
  hoverLabel: PropTypes.string,
  isMobile: PropTypes.bool,
};

const SaveAction = ({
  activeSubMenu,
  contentId,
  currentLevel,
  hoverLabel,
  isMobile,
}) => {
  if (isMobile && !!activeSubMenu) return null;

  // We are unable to use the SecondaryActionButton component
  // and the ActionPopOutOption component in here
  // because we are using the shared BookmarkButton.
  // Instead, we are using the styles for those components

  const css = {
    root: isMobile ? popOutOptionCss() : sharedButtonCss(false),
    Button: {
      root: [isMobile ? buttonCss : sharedButtonCss(false), buttonOverrideCss],
    },
    Icon: { root: isMobile ? mobileIconCss : desktopIconCss },
    label: labelCss,
  };

  const buttonContents = () => {
    return (
      <BookmarkContextProvider>
        <BookmarkButton
          contentId={contentId}
          currentLevelId={currentLevel?.id}
          hoverLabel={hoverLabel}
          iconColor="currentColor"
          __cssFor={css}
        />
      </BookmarkContextProvider>
    );
  };

  if (isMobile) return <li>{buttonContents()}</li>;

  return buttonContents();
};

SaveAction.propTypes = propTypes;

export default SaveAction;
